"use strict";
var __cov_xMPTqnXtiubmUa3k1igpag = (Function('return this'))();
if (!__cov_xMPTqnXtiubmUa3k1igpag.__coverage__) { __cov_xMPTqnXtiubmUa3k1igpag.__coverage__ = {}; }
__cov_xMPTqnXtiubmUa3k1igpag = __cov_xMPTqnXtiubmUa3k1igpag.__coverage__;
if (!(__cov_xMPTqnXtiubmUa3k1igpag['src/const.js'])) {
   __cov_xMPTqnXtiubmUa3k1igpag['src/const.js'] = {"path":"src/const.js","s":{"1":0,"2":0},"b":{},"f":{},"fnMap":{},"statementMap":{"1":{"start":{"line":0,"column":0},"end":{"line":0,"column":0},"skip":true},"2":{"start":{"line":1,"column":-8},"end":{"line":1,"column":-8}}},"branchMap":{}};
}
__cov_xMPTqnXtiubmUa3k1igpag = __cov_xMPTqnXtiubmUa3k1igpag['src/const.js'];
__cov_xMPTqnXtiubmUa3k1igpag.s['1']++;Object.defineProperty(exports,'__esModule',{value:true});__cov_xMPTqnXtiubmUa3k1igpag.s['2']++;var COMMANDS=exports.COMMANDS={default:'output',output:'output',update:'update'};



// WEBPACK FOOTER //
// ./coverage/const.js